//@flow
import { connect } from 'react-redux';
import CardRegistrationIssue from '../../components/payments/CardRegistrationIssuePage';

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(CardRegistrationIssue);
